
if (!window.createDataRetriever) {
    const protocol = window.location.hostname === "localhost" ? "http" : "https"
    const colors = {
        line: "#7635C2",
        altLine: "#b98389",
        previous: "#4d7420",
        current: "#81c235",
    };

    const baseOptions = {
        series: [],
        chart: {
            type: 'bar',
            height: 350,
            stacked: true,
            stackType: '100%'
        },
        colors: ["#0d1305", "#1a270b", "#273a10", "#344e15", "#41611b", "#4d7420", "#5a8825", "#679b2a", "#74af30", "#81c235", "#8ec849", "#9ace5d", "#a7d472", "#b3da86", "#c0e19a", "#cde7ae", "#d9edc2", "#e6f3d7", "#f2f9eb"],
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    position: 'bottom',
                    offsetX: -10,
                    offsetY: 0
                }
            }
        }],
        xaxis: {
            categories: [
                "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
                "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre",
            ],
        },
        fill: {
            opacity: 1
        },
        legend: {
            position: 'bottom',
        },
    };

    const config = {
        margin: {
            config: {
                baseUrl: `${protocol}://${window.location.host}/api/v0-dev/admin/margin`,
                anchor: '#chart-margin',
            },
            options: {
                ...baseOptions,
                chart: {
                    type: 'line',
                    height: 350,
                    stacked: false,
                },
                stroke: {
                    width: [0, 0, 2, 2],
                },
                yaxis: [{
                    title: { text: "CA" },
                }, {
                    opposite: true,
                    title: { text: "Marge" }
                }],
                tooltip: {
                    fixed: {
                        enabled: true,
                        position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                        offsetY: 30,
                        offsetX: 60
                    },
                },
                colors: [colors.previous, colors.current, colors.line, colors.altLine],
            },
        },
        daytoday: {
            config: {
                baseUrl: `${protocol}://${window.location.host}/api/v0-dev/admin/daytoday`,
                anchor: '#chart-daytoday',
            },
            options: {
                ...baseOptions,
                chart: {
                    type: 'line',
                    height: 350,
                    stacked: false,
                },
                stroke: {
                    width: [2, 2, 2],
                },
                yaxis: [{
                    title: { text: "Marge (absolu)" },
                }, {
                    opposite: true,
                    title: { text: "Marge (cumul)" }
                }],
                tooltip: {
                    fixed: {
                        enabled: true,
                        // position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                        // offsetY: 30,
                        // offsetX: 60
                    },
                },
                colors: [
                    '#b3da85',
                    // colors.current,
                    colors.previous,
                    colors.line,
                ],
            },
        },
        m2m: {
            config: {
                baseUrl: `${protocol}://${window.location.host}/api/v0-dev/admin/m2m`,
                anchor: '#chart-m2m',
            },
            options: {
                ...baseOptions,
                chart: {
                    type: 'line',
                    height: 350,
                    stacked: false,
                },
                stroke: {
                    width: [2, 2, 2],
                },
                yaxis: [{
                    title: { text: "Marge (absolu)" },
                }, {
                    opposite: true,
                    title: { text: "Marge (cumul)" }
                }],
                tooltip: {
                    fixed: {
                        enabled: true,
                        // position: 'topLeft', // topRight, topLeft, bottomRight, bottomLeft
                        // offsetY: 30,
                        // offsetX: 60
                    },
                },
                colors: [
                    '#b3da85',
                    // colors.current,
                    colors.previous,
                    colors.line,
                ],
            },
        },
        sales: {
            config: {
                baseUrl: `http://${window.location.host}/api/v0-dev/admin/sales`,
                anchor: '#chart-sales',
            },
            options: baseOptions,
        },
    };
    function createDayToDayChart(args) {
        const id = args.id;
        const configId = config[id];
        const currentConfig = configId.config;
        const anchor = currentConfig.anchor;
        const baseUrl = currentConfig.baseUrl;
        const chartOptions = configId.options;
        const chartAnchor = document.querySelector(anchor);
        const ret = {
            elementId: id,
            filters: args.filters ?? {},
            showChart: true,
            isLoading: false,
            isInitializing: true,
            anchor: chartAnchor,
            chart: null,
            dataCache: {},
            baseUrl,
            get key() {
                // const opts = this.options.reduce((acc, cur) => {
                //     return cur.selected ? [...acc, cur] : acc;
                // }, []).join("_");
                // return `${this.year}-${opts}`;
                return `${this.year}-${Object.entries(this.filters).map((entry) => `${entry[0]}-${entry[1]}`).join("_")}`;
            },
            get url() {
                console.log("getting url", this.filters);
                const url = new URL(this.baseUrl);
                if (id === "m2m") {
                    if (!!this.filters.from) {
                        url.searchParams.append("from", this.filters.from);
                    } else {
                        url.searchParams.append("from", "202501");
                    }
                    if (!!this.filters.to) {
                        url.searchParams.append("to", this.filters.to);
                    } else {
                        url.searchParams.append("to", "202512");
                    }
                    if (!!this.filters.agence) {
                        if (Array.isArray(this.filters.agence)) {
                            console.log("agence is an array");
                            for (let i = 0; i < this.filters.agence.length; i++) {
                                const ag = this.filters.agence[i];
                                console.log(ag);
                                url.searchParams.append("agence", ag);
                            }
                        } else {
                            console.log("agence is not an array", typeof this.filters.agence, this.filters.agence?.constructor?.name)
                            url.searchParams.append("agence", this.filters.agence);
                        }
                    } else {
                        url.searchParams.append("agence", "VSF26")
                    }
                } else {
                    if (!!this.filters.from) {
                        url.searchParams.append("from", this.filters.from);
                    } else {
                        url.searchParams.append("from", "20250101");
                    }
                    if (!!this.filters.to) {
                        url.searchParams.append("to", this.filters.to);
                    } else {
                        url.searchParams.append("to", "20250131");
                    }
                    if (!!this.filters.agence) {
                        if (Array.isArray(this.filters.agence)) {
                            console.log("agence is an array");
                            for (let i = 0; i < this.filters.agence.length; i++) {
                                const ag = this.filters.agence[i];
                                console.log(ag);
                                url.searchParams.append("agence", ag);
                            }
                        } else {
                            console.log("agence is not an array", typeof this.filters.agence, this.filters.agence?.constructor?.name)
                            url.searchParams.append("agence", this.filters.agence);
                        }
                    } else {
                        url.searchParams.append("agence", "VSF26")
                    }
                }
                return url.href;
            },
            addAgence(key) {
                if (!this.filters.agence) {
                    this.filters.agence = [key];
                    this.updateData();
                    return;
                }

                if (this.filters.agence.indexOf(key) !== -1) {
                    return;
                }

                this.filters.agence = [...this.filters.agence, key];
                this.updateData();
            },
            removeAgence(key) {
                if (!this.filters.agence) {
                    return;
                }
                const index = this.filters.agence.indexOf(key);
                if (index === -1) {
                    return;
                }
                const newAgence = [...this.filters.agence];
                newAgence.splice(index, 1);
                this.filters.agence = newAgence;
                this.updateData();
            },
            isAgenceSelected(key) {
                return this.filters.agence && this.filters.agence.indexOf(key) !== -1;
            },
            toggleAgence(key) {
                if (!this.filters.agence) {
                    this.filters.agence = [key];
                    this.updateData();
                    return;
                }

                const index = this.filters.agence.indexOf(key);
                if (index === -1) {
                    this.filters.agence = [...this.filters.agence, key];
                } else {
                    const newAgence = [...this.filters.agence];
                    newAgence.splice(index, 1);
                    this.filters.agence = newAgence;
                }
                console.log(this.filters.agence);
                this.updateData();
            },
            updateFilter(key, value) {
                this.filters = { ...this.filters, [key]: value };
                this.updateData();
            },
            updateFilters(args) {
                if (!Array.isArray(args) || args.length === 0) {
                    return;
                }
                const filters = { ...this.filters };
                for (let el of args) {
                    if (!Array.isArray(el)) {
                        continue;
                    }
                    filters[el[0]] = el[1];
                }
                this.filters = filters;
                this.updateData();
            },
            formatDate(d) {
                const m = d.getMonth() + 1;
                const day = d.getDate();
                return `${d.getFullYear()}${m < 10 ? '0' : ''}${m}${day < 10 ? '0' : ''}${day}`;
            },
            updateInterval(arg) {
                let d;
                if (arg.target && arg.target.value) {
                    d = new Date(arg.target.value);
                } else if (typeof arg === "string") {
                    d = new Date(arg);
                } else {
                    return;
                }
                const interval = this.monthInterval(d);

                this.updateFilters([
                    ['from', this.formatDate(interval[0])],
                    ['to', this.formatDate(interval[1])],
                ]);
            },
            monthInterval(dt) {
                const year = dt.getFullYear();
                const month = dt.getMonth();
                const ret = [new Date(year, month, 1), new Date(year, month + 1, 0)];
                return ret
            },
            // lifecycle
            async init() {
                this.isLoading = true;
                const response = await fetch(this.url);
                if (response.status !== 200) {
                    const text = await response.json();
                    console.error(`[${this.url}][${response.status}]: ${JSON.stringify(text)}`);
                    return;
                }

                const data = await response.json();
                if (!data) {
                    console.error(`[${this.url}][NO DATA]: no data for ${this.key}`);
                    return;
                }

                const keys = data.keys;
                const series = data.series;
                const key = this.key;
                const options = {
                    ...chartOptions,
                    xaxis: { categories: keys },
                };

                this.chart = new ApexCharts(this.anchor, {
                    ...options,
                    series,
                });
                this.dataCache[key] = series;
                this.chart.render();
                this.isLoading = false;
                this.isInitializing = false;
            },
            async updateData() {
                console.log(this.filters.agence);
                // if (this.options.filter((opt) => opt.selected).length === 0) {
                //     this.showChart = false;
                //     return;
                // }
                if (!this.showChart) {
                    this.showChart = true;
                }
                const key = this.key;
                this.isLoading = true;
                let series = this.dataCache[key];
                let keys = null;
                if (series === undefined) {
                    const response = await fetch(this.url);
                    if (response.status !== 200) {
                        const text = await response.json();
                        console.error(`[${this.url}][${response.status}]: ${JSON.stringify(text)}`);
                        this.isLoading = false;
                        return;
                    }

                    const data = await response.json();
                    if (!data) {
                        console.error(`[${this.url}][NO DATA]: no data for ${this.key}`);
                        this.isLoading = false;
                        return;
                    }
                    series = data.series;
                    keys = data.keys;
                    this.chart.updateOptions({
                        xaxis: { categories: keys },
                    });
                }
                this.chart.updateSeries(series);
                this.isLoading = false;
            },
        };
        return ret;
    }
    function createDataRetriever(args) {
        const id = args.id;
        const elementId = args.elementId;
        const selected = args.selected;
        const configId = config[id];
        const currentConfig = configId.config;
        const anchor = currentConfig.anchor;
        const baseUrl = currentConfig.baseUrl;
        const chartOptions = configId.options;
        const chartAnchor = document.querySelector(anchor);
        const years = ["2020", "2021", "2022", "2023", "2024"];
        const ret = {
            // general
            showChart: true,
            isLoading: false,
            isInitializing: true,
            anchor: chartAnchor,
            chart: null,
            dataCache: {},
            baseUrl,

            // year select
            year: "2024",
            yearOptions: years,

            // multi-select
            elementId,
            options: [],
            selected,
            selectedElms: [],
            show: false,

            // methods
            // getters
            get key() {
                // const opts = this.options.reduce((acc, cur) => {
                //     return cur.selected ? [...acc, cur] : acc;
                // }, []).join("_");
                // return `${this.year}-${opts}`;
                return `${this.year}-${this.options.filter((opt) => opt.selected).map((opt) => opt.value).join("_")}`;
            },
            get url() {
                const url = new URL(this.baseUrl);
                url.searchParams.append("year", this.year);
                if (this.options.length > 0) {
                    for (let i = 0; i < this.options.length; i++) {
                        const opt = this.options[i];
                        if (!opt.selected) {
                            continue;
                        }
                        url.searchParams.append("agence", opt.value);
                    }
                }
                return url.href;
            },
            // lifecycle
            async init() {
                this.isLoading = true;

                const options = document.getElementById(this.elementId)?.options;
                if (options) {
                    for (let i = 0; i < options.length; i++) {
                        this.options.push({
                            value: options[i].value,
                            text: options[i].innerText,
                            selected: Object.values(this.selected).includes(options[i].value)
                        });

                        if (this.options[i].selected) {
                            this.selectedElms.push(this.options[i])
                        }
                    }
                }

                const response = await fetch(this.url);
                if (response.status !== 200) {
                    const text = await response.json();
                    console.error(`[${this.url}][${response.status}]: ${JSON.stringify(text)}`);
                    return;
                }

                const data = await response.json();
                if (!data) {
                    console.error(`[${this.url}][NO DATA]: no data for ${this.key}`);
                    return;
                }

                const key = this.key;
                const series = data;
                this.chart = new ApexCharts(this.anchor, {
                    ...chartOptions,
                    series,
                });
                this.dataCache[key] = series;
                this.chart.render();
                this.isLoading = false;
                this.isInitializing = false;
            },
            // other
            onYearChange(e) {
                e.preventDefault();
                if (this.isLoading || this.isInitializing) {
                    return;
                }
                const year = e.target.value;
                if (this.year === year) {
                    return;
                }
                this.year = year;
                this.updateData();
            },
            async updateData() {
                if (this.options.filter((opt) => opt.selected).length === 0) {
                    this.showChart = false;
                    return;
                }
                if (!this.showChart) {
                    this.showChart = true;
                }
                const key = this.key;
                this.isLoading = true;
                let series = this.dataCache[key];
                if (series === undefined) {
                    series = await fetch(this.url)
                        .then((response) => response.json())
                        .then((data) => {
                            const series = data;
                            this.dataCache[key] = series;
                            return series;
                        });
                }
                this.chart.updateSeries(series);
                this.isLoading = false;
            },
            deselect() {
                setTimeout(() => {
                    this.selected = [];
                    this.selectedElms = [];
                    Object.keys(this.options).forEach((key) => {
                        this.options[key].selected = false;
                    });
                    this.updateData();
                }, 100)
            },
            // select given option
            select(index, event) {
                const targetOption = this.options[index];
                if (!targetOption.selected) {
                    targetOption.selected = true;
                    targetOption.element = event.target;
                    this.selected.push(targetOption.value);
                    this.selectedElms.push(targetOption);
                    this.updateData();
                } else {
                    this.selected.splice(this.selected.lastIndexOf(index), 1);
                    targetOption.selected = false;
                    const promises = [];
                    Object.keys(this.selectedElms).forEach((key) => {
                        if (this.selectedElms[key].value == targetOption.value) {
                            promises.push(new Promise((res) => setTimeout(() => {
                                this.selectedElms.splice(key, 1);
                                res();
                            }, 100)))
                        }
                    });
                    Promise.all(promises).then(() => this.updateData());
                }
            },
            // remove from selected option
            remove(index, option) {
                this.selectedElms.splice(index, 1);
                Object.keys(this.options).forEach((key) => {
                    const curOption = this.options[key];
                    if (curOption.value == option.value) {
                        curOption.selected = false;
                        Object.keys(this.selected).forEach((skey) => {
                            if (this.selected[skey] == option.value) {
                                this.selected.splice(skey, 1);
                            }
                        });
                    }
                });
                this.updateData();
            },
            // filter out selected elements
            selectedElements() {
                return this.options.filter(op => op.selected === true)
            },
            // get selected values
            selectedValues() {
                // return this.options.reduce((acc, cur) => cur.selected ? [...acc, cur.value] : acc, []);
                return this.options.filter(op => op.selected === true).map(el => el.value)
            },
        };
        return ret;
    }
    window.createDataRetriever = createDataRetriever;
    window.createDayToDayChart = createDayToDayChart;
};

